// Constants.
import * as DataSourcesConstants from 'constants/DataSourcesConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  types: [],
  errorMessage: '',
};

export default function datasourcesTypes(state = initialState, action = {}) {
  switch (action.type) {
    case DataSourcesConstants.LOAD_DATASOURCES_TYPES_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case DataSourcesConstants.LOAD_DATASOURCES_TYPES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        types: action.types,
      };
    case DataSourcesConstants.LOAD_DATASOURCES_TYPES_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        types: initialState.types,
        errorMessage: action.message,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        types: initialState.types,
        errorMessage: '',
      };
    default:
      return state;
  }
}
